import React, { memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumbs, Anchor, Paper, Box } from '@mantine/core';
import classes from './Breadcrumb.module.css';
import { IoHomeOutline } from "react-icons/io5";

const routeLabels: any = {
  '/manage-verticals': 'Category',
  '/manage-raw-material': 'Raw Materials',
  '/manage-raw-material/addrawmaterial': 'Add Raw Material',
  '/manage-verticals/addverticals': 'Add Verticals',
  '/manage-products-category': 'Sub Category',
  '/manage-products-category/addcategory': 'Add Sub Category',
  '/manage-verticals/addcategory': 'Add Category',
  '/newlca': 'Compute Report',
  '/newlca/sub-category': 'Sub Category',
  '/location': 'Location',
  '/location/addlocation': 'Add Location',
  '/transport': 'Transport',
  '/transport/addtransport': 'Add Transport',
  '/pallets': 'Pallets',
  '/pallets/addpallets': 'Add Pallets',
  '/package-box': 'Package Box',
  '/package-box/addpackagebox': 'Add Package Box',
  '/material-subtype': 'Material Sub Type',
  '/material-subtype/addmaterial-subtype': 'Add Sub Type',
  '/manage-customers': 'Customers',
  '/manage-customers/addcustomers': 'Add Customers',
  '/manage-products': 'Products',
  '/manage-products/addproduct': 'Add Product',
  '/manage-factory': 'Factory',
  '/manage-factory/addfactory': 'Add Factory',
  '/manage-db-version': 'DataBase Version',
  '/manage-db-version/add-db-version': 'Add DataBase Version',
  '/manage-process': 'Process',
  '/manage-process/addprocess': 'Add Process',
  '/disposal':'Disposal',
  '/disposal/add-disposal':'Add Disposal',
  '/lca-report': 'LCA Report',
  '/draft': 'Draft',
};

const DynamicBreadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items = pathSegments.map((segment, index) => {
    const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
    const label: any = routeLabels[path] || segment;
    
    // Skip creating a breadcrumb item for dashboard since it's added separately
    if (segment === 'dashboard') {
      return null;
    }

    return (
      <Anchor
        key={index}
        onClick={() => navigate(path)}
        style={{ cursor: 'pointer' }}
      >
        {label}
      </Anchor>
    );
  }).filter(Boolean); // Filter out null values

  return (
    <Paper shadow="xs" p="xs" radius="md">
      <Breadcrumbs separator=">" separatorMargin="xs" className={classes.breadcrumbs}>
      <Box>
        <Anchor  onClick={() => navigate('/dashboard')} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: '5px' }}>
          <IoHomeOutline size={13} /> Dashboard
        </Anchor>
      </Box>
        {items}
      </Breadcrumbs>
    </Paper>
  );
};

export default memo(DynamicBreadcrumbs);
